import type { components } from '@heidi/schema/ml-scribe';

import { sessionKeys } from '../../contracts';
import { getSessionDataConfig } from '../config';

// Structural alias of the app's `@/types` name (schema-derived there too); the
// `isPolling` flag is the hub's own cache-local addition.
type QuerySessionLiveTranscripts = components['schemas']['LiveTranscriptResponse'] & {
  isPolling?: boolean;
};

/** Cache-only read of this session's live-transcript response; undefined when unloaded. */
export const readLiveTranscriptCache = (
  sessionId: string
): QuerySessionLiveTranscripts | undefined =>
  getSessionDataConfig()
    .getQueryClient()
    .getQueryData<QuerySessionLiveTranscripts>(sessionKeys.liveTranscript(sessionId));
